import { optional } from 'inversify';
import { injectable, inject } from 'src/features/ioc';
import type { LoginScreenService } from 'src/services/LoginScreenService';
import type { ReactBindings } from 'src/types/bindings';

@injectable()
export class LoginScreenServiceImpl implements LoginScreenService {
    constructor(
        @inject('NavigationServiceProvider')
        @optional()
        private readonly navigationServiceProvider?: ReactBindings['NavigationServiceProvider'],
    ) {}

    showLoginScreen(url: string) {
        window.location.href = url;
    }

    async showLoggedOutScreen() {
        if (this.navigationServiceProvider) {
            const navigationService = await this.navigationServiceProvider();
            await navigationService.navigate('/loggedout');
            return;
        }

        window.location.assign('/loggedout');
    }
}
